import type { MediaGallery, MediaGalleryItem } from '@containers/admin/types'
import useApi from '@hooks/useApi'
import type { NullableNumber, NullableString } from '@shared_types/global_types'
import { asArray } from '@shared_utils/array_utils'

const URL_GALLERIES = 'api/gallery'

export default function useGalleryApi () {
  const { apiGet, apiPost, apiPut, apiDelete } = useApi()

  const getGalleries = async () => {
    const res = await apiGet<{ gallery: MediaGallery[] }>(URL_GALLERIES)
    return asArray(res.gallery)
  }

  return {
    createGallery: (info: MediaGallery, successMessage: string) => {
      return apiPost(URL_GALLERIES, info, { successMessage })
    },

    fetchGalleries: async (type: NullableString = null) => {
      const galleries = await getGalleries()
      return galleries.filter(g => g.type === type)
    },

    fetchGalleryById: async (id: number) => {
      const galleries = await getGalleries()
      return galleries.find(g => g.id === id)
    },

    addMedia: (galleryId: number, data: FormData, successMessage: string) => {
      data.append('gallery_id', galleryId.toString())
      return apiPost(`${URL_GALLERIES}/media/${galleryId}`, data, {
        successMessage
      })
    },

    editMedia: (data: MediaGalleryItem, successMessage: string) => {
      return apiPut(`${URL_GALLERIES}/media/details/${data.id}`, data, {
        successMessage
      })
    },

    editGallery: (galleryId: number, data: Partial<MediaGallery>, successMessage: string) => {
      return apiPut(`${URL_GALLERIES}/${galleryId}`, data, { successMessage })
    },

    deleteGallery: (galleryId: number, successMessage: string) => {
      return apiDelete(`${URL_GALLERIES}/${galleryId}`, {}, { successMessage })
    },

    deleteMedia: async (mediaId: NullableNumber, successMessage: string) => {
      return await apiDelete(`${URL_GALLERIES}/media/${mediaId}`, { successMessage })
    },

    fetchMedia: async (galleryId: number) => {
      const res = await apiGet<{ media: MediaGalleryItem[] }>(`${URL_GALLERIES}/media/${galleryId}`)
      return asArray(res.media)
    }
  }
}
